import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class CreateUser {
  email: string = ""
  firstname: string = ""
  lastname: string = ""
  phone: string = ""
  title: string = ""

  constructor(
    data: {
      email: string
      firstname: string
      lastname: string
      phone: string
      title: string
    } | null = null,
  ) {
    if (data) {
      this.email = data.email
      this.firstname = data.firstname
      this.lastname = data.lastname
      this.phone = data.phone
      this.title = data.title
    }
  }
}
